<template>
  <div class="Portables">
    <Button class="top-create--btn" type="primary" @click="showEditPortableModal('create')">
      {{ $t('plugins.createPortable') }}
    </Button>
    <Table :loading="loading" :columns="recordsCol" :data="records"></Table>
    <!--  create | edit -->
    <Modal
      v-model="createOrUpdateModalVisible"
      class-name="plugins-modal--create"
      :title="portableModalTitle"
      :width="600"
      :mask-closable="false"
      @on-ok="save"
    >
      <Form v-if="createOrUpdateModalVisible" ref="createForm" :model="createForm" :rules="rules">
        <Row>
          <i-col v-if="warningMessage !== ''" span="24">
            <Alert type="warning" show-icon closable @on-close="handleWarnClose">{{ warningMessage }}</Alert>
          </i-col>
          <i-col span="24">
            <FormItem :label="$t('common.name')" prop="name">
              <!-- <Select
                filterable
                allow-create
                v-model="createForm.name"
                size="large"
                :placeholder="$t('plugins.selectOrInput')"
                @on-change="handleNameChange"
                @on-create="handleCreateName"
              >
                <Option
                  v-for="(label, value) in availablePluginsMap"
                  :key="value"
                  :value="value"
                  :label="value"
                ></Option>
              </Select> -->
              <i-input
                v-model="createForm.name"
                :placeholder="$t('plugins.selectOrInput')"
                size="large"
                :disabled="isUpdatePortable"
              ></i-input>
            </FormItem>
          </i-col>
          <i-col span="24" class="file">
            <FormItem :label="$t('plugins.file')" prop="file">
              <a href="javascript:void(0);" class="upload-file--link" @click="showUploadFileModal">
                {{ $t('upload.uploadFile') }}
              </a>
              <FileListAutoCompeleteSeletor
                ref="fileListSelectRef"
                v-model="createForm.file"
                :prefix="'file://'"
              ></FileListAutoCompeleteSeletor>
            </FormItem>
          </i-col>
          <i-col span="24">
            <FormItem :label="$t('plugins.shellParas')" prop="shellParas">
              <Tooltip max-width="250px" transfer :content="$t('plugins.shellParasDesc')" placement="top">
                <Icon type="md-help-circle"></Icon>
              </Tooltip>
              <Select
                v-model="createForm.shellParas"
                filterable
                multiple
                allow-create
                size="large"
                :placeholder="$t('rules.enterCreate')"
                @on-create="addParams"
              >
                <Option v-for="(value, index) in shellOptions" :value="value" :key="index">
                  {{ value }}
                </Option>
              </Select>
            </FormItem>
          </i-col>
          <i-col v-if="functions.length !== 0" span="24">
            <FormItem :label="$t('plugins.functions')" prop="functions">
              <Tooltip max-width="250px" transfer :content="$t('plugins.functionsDesc')" placement="top">
                <Icon type="md-help-circle"></Icon>
              </Tooltip>
              <Select v-model="createForm.functions" filte rable multiple allow-create size="large">
                <Option v-for="(value, index) in functions" :value="value.name" :key="index.name">
                  {{ value.name }}
                </Option>
              </Select>
            </FormItem>
          </i-col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" @click="createOrUpdateModalVisible = false">{{ $t('common.cancel') }}</Button>
        <Button type="primary" :loading="btnLoading" @click="save">{{ $t('common.submit') }}</Button>
      </div>
    </Modal>

    <Modal
      v-model="viewModalVisible"
      class-name="plugins-modal--view view-form"
      :title="$t('plugins.viewPortable')"
      :width="500"
      :mask-closable="false"
    >
      <div class="view-item">
        <label class="view-item--label">{{ $t('common.name') }}: </label>
        <span>{{ viewForm.name }}</span>
      </div>
      <div class="view-item">
        <label class="view-item--label">{{ $t('common.version') }}: </label>
        <span>{{ viewForm.version }}</span>
      </div>
      <div slot="footer">
        <Button type="primary" @click="viewModalVisible = false">{{ $t('common.ok') }}</Button>
      </div>
    </Modal>

    <Modal
      v-model="showRegisterFuncVisisble"
      class-name="plugins-modal--view view-form"
      :title="$t('plugins.registerFunction')"
      :width="500"
      :mask-closable="false"
    >
      <Select
        v-model="registerFuncForm.functions"
        filterable
        multiple
        allow-create
        size="large"
        @on-create="handleCreateName"
      >
        <Option v-for="(value, index) in functions" :value="value.name" :key="index.name">
          {{ value.name }}
        </Option>
      </Select>
      <div slot="footer">
        <Button type="text" @click="showRegisterFuncVisisble = false">{{ $t('common.cancel') }}</Button>
        <Button type="primary" :loading="btnLoading" @click="registerFunctions">{{ $t('common.submit') }}</Button>
      </div>
    </Modal>

    <!-- Upload File -->
    <UploadFileModal
      :modalVisible.sync="uploadFileModalVisible"
      :isSupportCustom="true"
      :fileAccepts="'.zip'"
      @reload="getFileList"
    />
  </div>
</template>

<script lang="jsx">
import { loadAllFunctions } from '@/api/rules'
import {
  createPortable,
  updatePortable,
  loadPortables,
  viewPortable,
  deletePortable,
  loadAvailablePortables,
  registerFunc,
} from '@/api/portables'
import nodeID from '@/mixins/nodeID'
import FileListAutoCompeleteSeletor from '../../configuration/uploads/components/FileListAutoSelector.vue'
import UploadFileModal from '../../configuration/uploads/UploadFileModal.vue'

export default {
  name: 'Portables',

  mixins: [nodeID],

  components: { FileListAutoCompeleteSeletor, UploadFileModal },

  data() {
    return {
      loading: false,
      createOrUpdateModalVisible: false,
      isUpdatePortable: false,
      viewModalVisible: false,
      showRegisterFuncVisisble: false,
      btnLoading: false,
      registerFuncForm: {
        name: '',
        functions: [],
      },
      warningMessage: '',
      viewForm: {},
      availablePluginsMap: {},
      shellOptions: [''],
      functions: [],
      createForm: {
        shellParas: [],
      },
      rules: {
        name: [{ required: true, message: this.$t('plugins.nameRequired') }],
        file: [{ required: true, message: this.$t('plugins.fileRequired') }],
      },
      records: [],
      recordsCol: [
        {
          title: this.$t('common.name'),
          key: 'name',
          render: (h, params) => {
            return (
              <div>
                <a
                  href="javascript:;"
                  onClick={() => {
                    this.showDetail(params.row)
                  }}
                >
                  {params.row.name}
                </a>
              </div>
            )
          },
        },
        {
          title: 'sources',
          key: 'sources',
          render: (h, params) => {
            return <div>{params.row.sources.join(',')}</div>
          },
        },
        {
          title: 'sinks',
          key: 'sinks',
          render: (h, params) => {
            return <div>{params.row.sinks.join(',')}</div>
          },
        },
        {
          title: 'functions',
          key: 'functions',
          render: (h, params) => {
            return <div>{params.row.functions.join(',')}</div>
          },
        },
        {
          title: this.$t('common.operations'),
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            const editFuncBtn = (
              <a
                href="javascript:;"
                style="margin-right: 10px;"
                vOn:click={() => {
                  this.showRegisterFunctions(params.row)
                }}
              >
                <Icon type="ios-paper-plane" />
              </a>
            )
            return (
              <div>
                <a
                  href="javascript:;"
                  style="margin-right: 10px;"
                  vOn:click={() => {
                    this.showEditPortableModal('update', params.row)
                  }}
                >
                  <Icon type="md-refresh" />
                </a>
                {params.row.type === 'functions' ? editFuncBtn : null}
                <a href="javascript:;">
                  <Poptip
                    confirm={true}
                    transfer={true}
                    width={200}
                    title={this.$t('plugins.deletePortableWarning')}
                    placement="top"
                    type="error"
                    vOn:on-ok={() => {
                      this.remove(params.row)
                    }}
                    vOn:on-cancel={() => {}}
                  >
                    <Icon type="md-trash"></Icon>
                  </Poptip>
                </a>
              </div>
            )
          },
        },
      ],
      uploadFileModalVisible: false,
    }
  },

  computed: {
    portableModalTitle() {
      return this.isUpdatePortable ? this.$t('plugins.updatePortable') : this.$t('plugins.createPortable')
    },
  },

  watch: {
    createOrUpdateModalVisible(val) {
      if (!val) {
        this.$refs.createForm.resetFields()
        this.createForm = {
          shellParas: [],
        }
        this.isUpdatePortable = false
        this.warningMessage = ''
        this.availablePluginsMap = {}
      }
    },
  },

  created() {
    const { query } = this.$route
    const { pluginName } = JSON.parse(sessionStorage.getItem('installInfo')) || {}
    if (['sources', 'sinks'].includes(query.fromPageType)) {
      this.createForm.name = pluginName
      this.getAvailablePlugins(pluginName)
      setTimeout(() => {
        this.createOrUpdateModalVisible = true
      }, 500)
    }
    sessionStorage.removeItem('installInfo')
    this.loadData()
  },

  methods: {
    loadData() {
      this.loading = true
      this.records = []
      Promise.all([loadPortables(this.nodeID, 'portables')])
        .then((res) => {
          const records = res.map((item) => {
            const { data } = item
            return {
              data,
            }
          })
          records.forEach((record) => {
            record.data.forEach((col) => {
              this.records.push({
                ...col,
              })
            })
          })
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    showDetail({ name }) {
      this.viewModalVisible = true
      viewPortable(this.nodeID, name)
        .then((res) => {
          this.viewForm = res.data
        })
        .catch(() => {})
    },
    // Register Functions
    showRegisterFunctions({ name }) {
      this.showRegisterFuncVisisble = true
      this.registerFuncForm.name = name
      this.registerFuncForm.functions = []
      this.loadPortablesMetaData(name)
    },
    registerFunctions() {
      if (this.registerFuncForm.functions.length === 0) {
        this.$Message.warning(this.$t('plugins.functionsRequired'))
        return
      }
      const { name, functions } = this.registerFuncForm
      const data = { functions }
      registerFunc(this.nodeID, name, data).then((res) => {
        this.registerForm = {
          name: '',
          functions: [],
        }
        this.$Message.success(res.data)
        this.showRegisterFuncVisisble = false
      })
    },

    // remove
    remove({ name }) {
      deletePortable(this.nodeID, name)
        .then((res) => {
          if (res.status === 200 && res.statusText === 'OK') {
            this.$Modal.success({
              title: this.$t('common.deleteSuccess'),
              content: this.$t('plugins.deleteNotice'),
            })
          } else {
            this.$Message.success(this.$t('common.deleteSuccess'))
          }
          this.loadData()
        })
        .catch(() => {})
    },

    // show create | edit portable modal
    showEditPortableModal(operator = 'create', row) {
      this.createOrUpdateModalVisible = true
      this.isUpdatePortable = operator !== 'create'

      if (operator === 'update') {
        const { name } = row
        this.createForm = {
          name,
          file: '',
          shellParas: [],
        }
        this.loadPortablesMetaData(name)
      }
    },

    // edit portable
    editPortable(data) {
      updatePortable(this.nodeID, data)
        .then(() => {
          this.$Message.success(this.$t('common.updateSuccess'))
          this.loadData()
          this.createOrUpdateModalVisible = false
        })
        .finally(() => {
          this.btnLoading = false
        })
    },

    // create portable
    createNewPortable(data) {
      createPortable(this.nodeID, data)
        .then((res) => {
          if (res.status === 201 && res.statusText === 'Created') {
            this.$Message.success(res.data)
          } else {
            this.$Message.success(this.$t('common.addSuccess'))
          }
          this.loadData()
          this.createOrUpdateModalVisible = false
        })
        .finally(() => {
          this.btnLoading = false
        })
    },

    save() {
      this.$refs.createForm.validate((valid) => {
        if (!valid) {
          return
        }
        this.btnLoading = true
        const data = { ...this.createForm }
        const { shellParas } = data
        data.shellParas = shellParas.filter((param) => param !== '')
        delete data.type
        if (this.isUpdatePortable) {
          this.editPortable(data)
        } else {
          this.createNewPortable(data)
        }
      })
    },

    getAvailablePlugins(name) {
      loadAvailablePortables(this.nodeID)
        .then((res) => {
          this.availablePluginsMap = res.data
          if (name) {
            this.handleNameChange(name)
          }
        })
        .catch((error) => {
          this.warningMessage = error.response.data
        })
    },
    loadPortablesMetaData(name) {
      loadAllFunctions(this.nodeID).then((res) => {
        res.data.forEach((item) => {
          if (item.name === name) {
            this.functions = item.functions
          }
        })
      })
    },
    handleNameChange(name) {
      const file = this.availablePluginsMap[name]
      this.$set(this.createForm, 'file', file)
    },
    handleCreateName(name) {
      this.createForm.name = name
      this.availablePluginsMap[name] = ''
      this.$set(this.createForm, 'file', '')
    },
    handleCreateFunc(func) {
      this.registerForm.function.push(func)
    },
    handleWarnClose() {
      this.warningMessage = ''
    },
    addParams(val) {
      this.shellOptions.push(val)
    },
    showUploadFileModal() {
      this.uploadFileModalVisible = true
    },
    getFileList() {
      this.$refs.fileListSelectRef.getFileList()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins.scss';

::v-deep .file .ivu-form-item-content {
  @include clearfix();
}
.upload-file--link {
  float: right;
  color: var(--color-text-normal);
}
</style>
